const STICKER_DURATION_DAYS = 30;

export const isNewFeature = (
  feature: string,
  releaseMap: Record<string, Date>
): boolean => {
  const releaseDate = releaseMap[feature];
  if (!releaseDate) return false;

  const now = new Date();
  const msInDay = 24 * 60 * 60 * 1000;
  const daysSinceRelease = (now.getTime() - releaseDate.getTime()) / msInDay;

  return daysSinceRelease <= STICKER_DURATION_DAYS;
};
